const config = {
    mic:{
        restApis:{
            bathInstructTaskCount:"/mic/cmd-task/count?",//模糊搜索
            bathInstructTaskList:"/mic/cmd-task/list?",//行程分布接口
            exportBathInstructTask:"/rest/instruction/task/export?",//创建导出任务
            cancelTask:"/mic/cmd-task?taskId=",//报警配置
            addModifyTask:"/mic/cmd-task",
            taskDetail:"/mic/cmd-task?taskId=",
            taskLogCount:"",
            taskLogList:"",
            taskLogExport:"",
            delTaskPush:"/rest/app/push/task/",
            taskHistoryList:"/rest/instruction/task/history/list?",
            devicesList:"/mic/car/pageable-select-car-list",
            devicesCount:"/mic/car/pageable-select-car-count",
            deviceSearch:"/mic/car/select-car",
            batchCheck:"/mic/cmd-task/device/check/",
            exeHistory:"/mic/cmd-task/device-exec-histories"
        },
        exportTask:true,
        isDeviceMgt:false,//车辆维度管理
        hasEnum:true,
        listKey:"imei",
    },
    iop:{
        restApis:{
            bathInstructTaskCount:"/rest/instruction/task/count?",
            bathInstructTaskList:"/rest/instruction/task/list?",
            exportBathInstructTask:"/rest/instruction/task/export",
            cancelTask:"/rest/instruction/task/cancel?taskId=",
            addModifyTask:"/rest/instruction/task",
            taskDetail:"/rest/instruction/task/info?taskId=",
            taskLogCount:"/rest/instruction/task/detail/count?",
            taskLogList:"/rest/instruction/task/detail/list?",
            taskLogExport:"/rest/instruction/task/detail/export?",
            delTaskPush:"/rest/app/push/task/",
            taskStatusEnum:"/rest/instruction/task/status/enum",
            taskInstructTypeEnum:"/rest/instruction/task/instruction/enum",
            taskHistoryList:"/rest/instruction/task/history/list?",
            devicesList:"/rest/device/search/list",
            devicesCount:"/rest/device/search/count",
            batchCheck:"/rest/device/batch/check/",
        },
        exportTask:false,
        isDeviceMgt:true,//设备维度管理
        hasEnum:false,//没有全局的数据字典，需要有单独的接口获取
        listKey:"imei",//列表中获取的展示的key
    }
}
export default config